import { useTranslation } from "react-i18next";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Badge } from "@/components/ui/badge";
import { useHistoryFilters } from "../hooks/useHistoryFilters";
import { getActionVariant } from "../utils";
import { RESOURCE_TYPES, ACTION_OPTIONS } from "./history-filter-component";

const ALL_VALUE = "__all__";

const HistoryInlineFilters = () => {
  const { t } = useTranslation();
  const [filters, setFilters] = useHistoryFilters();

  return (
    <>
      <Select
        value={filters.model_type ?? ALL_VALUE}
        onValueChange={(value) =>
          setFilters({ model_type: value === ALL_VALUE ? null : value })
        }
      >
        <SelectTrigger>
          <SelectValue
            placeholder={t("modules.history.keys.filter_by_resource")}
          />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value={ALL_VALUE}>
            {t("modules.history.keys.all_resources")}
          </SelectItem>
          {RESOURCE_TYPES.map((type) => (
            <SelectItem key={type} value={type}>
              <Badge variant="secondary">{t(`keys.resources.${type}`)}</Badge>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>

      <Select
        value={filters.action !== null ? String(filters.action) : ALL_VALUE}
        onValueChange={(value) =>
          setFilters({
            action: value === ALL_VALUE ? null : Number(value),
          })
        }
      >
        <SelectTrigger>
          <SelectValue
            placeholder={t("modules.history.keys.filter_by_action")}
          />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value={ALL_VALUE}>
            {t("modules.history.keys.all_actions")}
          </SelectItem>
          {ACTION_OPTIONS.map((option) => (
            <SelectItem key={option.value} value={String(option.value)}>
              <Badge variant={getActionVariant(option.key)}>
                {t(`keys.action_types.${option.key}`)}
              </Badge>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>

      <Select
        value={filters.ordering ?? "-timestamp"}
        onValueChange={(value) => setFilters({ ordering: value })}
      >
        <SelectTrigger>
          <SelectValue placeholder={t("modules.history.keys.sort_by_date")} />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="-timestamp">
            {t("modules.history.filters.by_date")} — Desc
          </SelectItem>
          <SelectItem value="timestamp">
            {t("modules.history.filters.by_date")} — Asc
          </SelectItem>
        </SelectContent>
      </Select>
    </>
  );
};

export default HistoryInlineFilters;
